<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Production Template Raw Materials</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="accent" text to="/production-templates">
                    <v-icon left>mdi-keyboard-backspace</v-icon> back
                </v-btn>
            </v-toolbar>
            <v-card-text>

                <v-row class="subtitle-2 text--primary">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-row>

                <v-row class="subtitle-2 text--primary">
                    <v-col cols="12">
                        <v-btn text @click.native="newItemDialog = true" color="accent" class="mt-1">
                            <v-icon left>mdi-plus</v-icon> Add Item To List
                        </v-btn>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                        <!-- start of table -->
                        <v-data-table :items-per-page="pageItems" :headers="headers" :items="records" :search="search"
                            :mobile-breakpoint="zeroValue">

                            <!-- edit template -->
                            <template v-slot:item.edit="{ item }">
                                <v-btn color="accent" text @click="openEditDialog(item)">
                                    <v-icon left>mdi-pencil</v-icon> Edit
                                </v-btn>
                            </template>
                            <!-- end -->

                            <!-- edit template -->
                            <template v-slot:item.delete="{ item }">
                                <v-btn color="red" text @click="openDeleteDialog(item)">
                                    <v-icon left>mdi-delete</v-icon> Delete
                                </v-btn>
                            </template>
                            <!-- end -->
                        </v-data-table>
                        <!-- end -->
                    </v-col>
                </v-row>

                <!-- product dialog modal-->
                <v-dialog v-model="deleteDialog" max-width="750px">
                    <v-card>
                        <v-toolbar dense color="secondary" flat>
                            <v-toolbar-title> Delete Production Raw Material </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click.native="deleteDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-container fluid>
                                <v-row class="text--primary subtitle-2">
                                    <v-col cols="12">
                                        Are you sure you want to delete / disable this item ?
                                    </v-col>
                                    <v-col cols="12">
                                        <span style="font-size: 20px">{{ productionItem.product &&
                                            productionItem.product.Name }}</span>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-btn color="red" dark :loading="loader" @click="deleteProduct">Yes,
                                            Delete</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- end of modal-->

                <!-- raw material edit dialog -->
                <v-dialog v-model="editDialog" max-width="750px">
                    <v-card>
                        <v-toolbar dense color="secondary" flat>
                            <v-toolbar-title>Edit Raw Material </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click.native="editDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="style-16">{{ productionItem.product && productionItem.product.Name
                                        }}</span>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field outlined dense label="Quantity"
                                            v-model="productionItem.Quantity"></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field outlined dense label="Price"
                                            v-model="productionItem.Price"></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-btn color="primary" @click="updateRawMaterial" :loading="loader">
                                            <v-icon left>mdi-content-save</v-icon> Update
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- end of edit modal-->
            </v-card-text>
        </v-card>

        <!-- new item  modal -->
        <v-dialog v-model="newItemDialog" max-width="650px">
            <v-card>
                <v-toolbar dense color="secondary" flat>
                    <v-toolbar-title>Add Item To Raw Materials</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="newItemDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12" xs="12" md="12">
                                <v-autocomplete autocomplete="off" v-model="rawMaterial.id" :items="products"
                                    :search-input.sync="searchProducts" item-text="Name" item-value="id" cache-items
                                    class="mt-2" flat hide-no-data hide-details label="Search Product" outlined
                                    dense></v-autocomplete>
                            </v-col>

                            <v-col cols="12" xs="6" md="4">
                                <v-text-field autocomplete="off" type="number" v-model="rawMaterial.Quantity"
                                    label="Quantity" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="12" xs="6" md="4">
                                <v-autocomplete autocomplete="off" dense outlined single-line
                                    v-model="rawMaterial.UomEntry" :items="uoms" label="Unit" item-text="UomName"
                                    item-value="id"></v-autocomplete>
                            </v-col>

                            <v-col cols="12" xs="6" md="4">
                                <v-text-field autocomplete="off" type="number" v-model="rawMaterial.Price" label="Price"
                                    outlined dense></v-text-field>
                            </v-col>


                            <v-col cols="12" xs="6" md="12">
                                <span class="style-16">Total: {{ parseFloat(rawMaterial.Quantity) *
                                    parseFloat(rawMaterial.Price) }}</span>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-btn color="primary" @click="addToList" :loading="loader">
                                    <v-icon left>mdi-plus</v-icon> Add To List
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- end of modal -->

        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        search: "",
        products: [],
        uoms: [],
        productionItem: {},
        rawMaterial: {},
        newItemDialog: false,
        customersDialog: false,
        editDialog: false,
        deleteDialog: false,
        searchProducts: null,
        loader: false,
        zeroValue: 0,
        pageItems: 100,
        date: null,
        headers: [
            { text: "Product", value: "product.Name" },
            { text: "Quantity", value: "Quantity" },
            { text: "Unit", value: "UOM.UomName" },
            { text: "Price", value: "Price" },
            { text: "Total", value: "LineTotal" },
            { text: "Edit", value: "edit" },
            { text: "Delete", value: "delete" },
        ],
        records: [],
        excelFile: null
    }),
    watch: {
        searchProducts(val) {
            if (val && val !== this.select && this.querySelections(val)) {
                this.querySelections(val);
            }
        },
        "$route.params.id": {
            handler: "getById",
            immediate: true
        }
    },
    methods: {
        querySelections(searchText) {
            const self = this;
            const url = "/products/search";

            const data = {
                searchText: searchText.toString(),
                CustomerId: 0
            };
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        if (res.ResponseData != null) {
                            self.products = res.ResponseData;
                        }
                    } else {
                        self.$store.commit("btnLoader", false);
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.$store.commit("btnLoader", false);
                    this.$refs.snackbar.show(err, "red");
                });
        },
        openEditDialog(data) {
            this.productionItem = data;
            this.editDialog = true;
        },
        openDeleteDialog(data) {
            this.productionItem = data;
            this.deleteDialog = true;
        },
        addToList() {
            var templateId = this.$route.params.id;
            var data = {
                templateId: parseInt(templateId),
                rawMaterialId: parseInt(this.rawMaterial.id),
                UomEntry: this.rawMaterial.UomEntry,
                Quantity: parseFloat(this.rawMaterial.Quantity),
                Price: parseFloat(this.rawMaterial.Price),
                LineTotal: parseFloat(this.rawMaterial.Quantity) * parseFloat(this.rawMaterial.Price),
            };

            const url = "/add-item-to-template";
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        this.$refs.snackbar.show("Created successful", "green");
                        location.reload();
                        self.loader = false;
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        },
        updateRawMaterial() {
            var rowId = this.productionItem.id;
            var editedData = this.productionItem;
            var data = {
                "id": parseInt(rowId),
                "Quantity": parseFloat(editedData.Quantity),
                "Price": parseFloat(editedData.Price),
                "LineTotal": parseFloat(editedData.Quantity) * parseFloat(editedData.Price),
            };

            const url = `/update-raw-material-data`;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.editDialog = false;
                        self.$refs.snackbar.show("Price updated successfully", "green");
                        location.reload();
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    self.$refs.snackbar.show(err, "red");
                });
        },
        getById(val) {
            const self = this;
            this.$store
            this.$store
                .dispatch("get", `/production-template/${val}`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.records = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        deleteProduct() {
            const url = `/delete/raw/material/${this.productionItem.id}`;
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("remove", url)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        location.reload();
                    } else {
                        self.loader = false;
                        self.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    self.loader = false;
                    self.$refs.snackbar.show(err, "red");
                });
        },
        getUoms() {
            const self = this;
            this.loading = true;
            this.$store
                .dispatch("get", `/uoms`)
                .then(res => {
                    self.uoms = res.ResponseData;
                    self.loading = false;
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        }
    },
    created() {
        this.getUoms();
    }
};
</script>